import type { FC } from "react";
import { twMerge } from "tailwind-merge";

export interface AlpharunMarkProps {
  /** Merged into the chip so surfaces can recolor/resize it. */
  className?: string;
}

/**
 * The Alpharun logo in a small rounded chip, used across the chat surfaces
 * (suggestion rows, context pills, history headers). Decorative only — always
 * pair it with visible or accessible text.
 */
export const AlpharunMark: FC<AlpharunMarkProps> = ({ className }) => (
  <span
    aria-hidden
    className={twMerge(
      "flex size-5 shrink-0 items-center justify-center rounded-md bg-tooltip p-1 text-tooltip-foreground",
      className,
    )}
  >
    <svg
      className="size-full"
      fill="none"
      viewBox="0 0 350 350"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M251.585 87.8019C251.698 87.6145 251.901 87.5 252.12 87.5H348.892C349.379 87.5 349.679 88.0316 349.427 88.4481L244.479 262.198C244.366 262.385 244.163 262.5 243.944 262.5H147.172C146.685 262.5 146.385 261.968 146.637 261.552L251.585 87.8019Z"
        fill="currentColor"
      />
      <path
        d="M203.615 87.8019C203.728 87.6145 203.931 87.5 204.15 87.5H227.286C227.773 87.5 228.073 88.0316 227.821 88.4481L122.873 262.198C122.76 262.385 122.557 262.5 122.338 262.5H99.2014C98.7148 262.5 98.4148 261.968 98.6664 261.552L203.615 87.8019Z"
        fill="currentColor"
      />
      <path
        d="M154.568 87.8019C154.681 87.6145 154.884 87.5 155.103 87.5H178.239C178.726 87.5 179.026 88.0316 178.774 88.4481L73.8263 262.198C73.7131 262.385 73.5102 262.5 73.2913 262.5H50.1546C49.6679 262.5 49.368 261.968 49.6196 261.552L154.568 87.8019Z"
        fill="currentColor"
      />
      <path
        d="M105.521 87.8019C105.634 87.6145 105.837 87.5 106.056 87.5H129.193C129.679 87.5 129.979 88.0316 129.728 88.4481L24.7794 262.198C24.6662 262.385 24.4633 262.5 24.2444 262.5H1.10768C0.621043 262.5 0.321093 261.968 0.572693 261.552L105.521 87.8019Z"
        fill="currentColor"
      />
    </svg>
  </span>
);
